

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router/index'
import App from './App'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import VueScroller from 'vue-scroller'
import '@/styles/rootTheme.less'







Vue.use(WechatPlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(VueScroller)


FastClick.prototype.focus = function (targetElement) {
let length;
if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
length = targetElement.value.length;
targetElement.focus();
targetElement.setSelectionRange(length, length);
} else {
targetElement.focus();
}
}
FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
data() {
return {
themeType: 'yellow' 
}
},
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js